import React from 'react';
import {
  Box,
  Collapse,
  IconButton,
  Paper,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

type Props = {
  title: string;
  subtitle?: string;
  defaultOpen?: boolean;
  headerRight?: React.ReactNode;
  onToggle?: (o:boolean) => void;
  children: React.ReactNode;
};

type State = {
  open: boolean;
};

class BieCollapsibleSection extends React.PureComponent<Props, State> {
  state: State = {
    open: this.props.defaultOpen ?? true,
  };

  toggle = () => {
    const {open} = this.state;
    this.setState({ open: !open });
    if(this.props.onToggle) this.props.onToggle(!open);
  };

  render() {
    const { title, subtitle, headerRight, children } = this.props;
    const { open } = this.state;

    return (
      <Paper elevation={1} sx={{ mb: 2, overflow: 'hidden' }}>
        <Box
          sx={{
            px: 2,
            py: 1.25,
            bgcolor: '#f5f7fa',
            borderBottom: open ? '1px solid #e0e0e0' : 'none',
          }}
        >
          <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
            <Box sx={{ minWidth: 0 }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                {title}
              </Typography>
              {subtitle && (
                <Typography variant="caption" color="text.secondary">
                  {subtitle}
                </Typography>
              )}
            </Box>

            <Stack direction="row" alignItems="center" spacing={1}>
              {headerRight}
              <Tooltip title={open ? 'Collapse section' : 'Expand section'}>
                <IconButton size="small" onClick={this.toggle}>
                  {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </IconButton>
              </Tooltip>
            </Stack>
          </Stack>
        </Box>

        <Collapse in={open} timeout="auto" unmountOnExit>
          <Box sx={{ p: 2 }}>
            {children}
          </Box>
        </Collapse>
      </Paper>
    );
  }
}

export default BieCollapsibleSection;
